export enum StartupState {
    LOADING = 'loading',
    ERROR = 'error',
    READY = 'ready',
    REDIRECTING = 'redirecting'
}
